
import Vue from 'vue'
import request from './request'


const way =  './graphql/suppliers/', environment = '/tenders'
export default class SuppliersApi {

  async getSuppliersShortStatistic( model ) {
    return await request( {
      environment, way, name: 'getSuppliersShortStatistic',
      type: 'query',
      variables: {model},
      has_catch: true })
  }

  async getTenderSuppliersInfo( model ) {
    return await request( {
      environment, way, name: 'getTenderSuppliersInfo',
      type: 'query',
      variables: {model},
      has_catch: true })
  }

  async getCrmVerificationFillingInfo( ) {
    return await request( {
      environment, way, name: 'getCrmVerificationFillingInfo',
      type: 'query',
      has_catch: true })
  }

  async getSupplierBids( {supplierOrgId, skip, take } ) {
    return await request( {
      environment, way, name: 'getSupplierBids',
      type: 'query',
      variables: {supplierOrgId, skip, take},
      has_catch: true })
  }

  async getParticipationByTenderCategory( model) {
    return await request( {
      environment, way, name: 'getParticipationByTenderCategory',
      type: 'query',
      variables: { model },
      has_catch: true })
  }

  async getTenderSupplierWithVerification( supplierOrgId ) {
    return await request( {
      environment, way, name: 'getTenderSupplierWithVerification',
      type: 'query',
      variables: { supplierOrgId },
      has_catch: true })
  }

  async createOrUpdateSupplierVerification( model, tenderId ) {
    //model.comment = model.comment ?? ''
    return await request( {
      environment, way, name: 'createOrUpdateSupplierVerification',
      type: 'mutation',
      variables: { model, tenderId }})
  }


  async getRatingCriterias( ) {
    return await request( {
      environment, way, name: 'getRatingCriterias',
      type: 'query',
      has_catch: true,
      callback: res => res?.data?.ratingCriterias })
  }

  async getSupplierRatings( { supplierOrgId } ) {
    return await request( {
      environment, way, name: 'getSupplierRatings',
      type: 'query',
      variables: { supplierOrgId},
      has_catch: true })
  }

  async getTenderSupplierParticipants( supplierOrgId ) {
    return await request( {
      environment, way, name: 'getTenderSupplierParticipants',
      type: 'query',
      variables: {supplierOrgId},
      has_catch: true })
  }

  async getSupplierTenders( {supplierOrgId, skip, take } ) {
    return await request( {
      environment, way, name: 'getSupplierTenders',
      type: 'query',
      variables: { supplierOrgId, skip, take },
      has_catch: true })
  }

  async getCrmSupplierVerificationByTender( tenderId ) {
    return await request( {
      environment, way, name: 'getCrmSupplierVerificationByTender',
      type: 'query',
      variables: { tenderId },
      has_catch: true })
  }


  async setBidderRating( model ) {
    return await request( {
      environment, way, name: 'setBidderRating',
      type: 'mutate',
      variables: { model },
      catch_callback: error => {
        Vue.prototype.$log_error(error.message)
        throw error
      }
    })
  }

}
